import React, { useState, useEffect } from "react";

// ========== Inline SVG Icons (Unchanged) ==========
const CloseIcon = ({ size = 24, color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
);
const ViewIcon = ({ size = 20, color = "#555" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
);
const DownloadIcon = ({ size = 20, color = "#555" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
);
const HistoryIcon = ({ size = 22, color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 4v6h6" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></svg>
);

// ========== STYLES (Inline CSS Objects - Unchanged) ==========
const styles = {
    modalOverlay: { position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0, 0, 0, 0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000, },
    modalContent: { backgroundColor: "#ffffff", padding: "0", borderRadius: "10px", boxShadow: "0 5px 20px rgba(0,0,0,0.3)", width: "90%", maxWidth: "700px", height: "90vh", display: "flex", flexDirection: "column", animation: "fadeIn 0.3s ease-out", },
    modalHeader: { padding: "1rem 1.5rem", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e5e5e5", flexShrink: 0, },
    modalBody: { padding: "1.5rem", overflowY: "auto", flexGrow: 1, },
    modalTitle: { margin: 0, fontSize: "1.5rem", color: "#333" },
    closeButton: { background: "transparent", border: "none", fontSize: "1.75rem", cursor: "pointer", color: "#888", padding: 0, display: "flex", },
    historyListItemInModal: { backgroundColor: "#f9f9f9", padding: "1.5rem", borderRadius: "8px", border: "1px solid #eee", marginBottom: "1.5rem", },
    historyItemHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "1px solid #ddd", paddingBottom: "10px", marginBottom: "15px", },
    historyItemTitle: { margin: 0, fontSize: "1.25rem", color: "#222", },
    historyItemDate: { margin: "5px 0 0 0", color: "#666", fontSize: "0.9rem", flexShrink: 0, marginLeft: "1rem", },
    historyItemDescription: { color: "#333", lineHeight: "1.6", whiteSpace: "pre-wrap", marginBottom: "1rem", },
    readMoreButton: { background: "none", border: "none", color: "#007bff", cursor: "pointer", padding: "0", fontWeight: "bold", fontSize: "0.9rem", },
    historyItemFilesLabel: { fontWeight: "bold", color: "#555", marginBottom: "10px", fontSize: "0.9rem", textTransform: "uppercase", marginTop: "1.5rem", },
    historyFileList: { listStyle: "none", padding: 0, margin: 0, },
    historyFileItem: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", backgroundColor: "#fff", border: "1px solid #e9e9e9", borderRadius: "6px", marginBottom: "8px", },
    fileInfo: { fontWeight: "500", fontSize: "0.9rem", wordBreak: "break-all" },
    fileActions: { display: "flex", gap: "15px", flexShrink: 0, marginLeft: "10px" },
    actionIcon: { cursor: "pointer", textDecoration: "none", color: "#555" },
    emptyHistoryState: { textAlign: "center", padding: "3rem 1rem", color: "#777", },
};

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

// Internal component for a single history item (Unchanged)
const HistoryItem = ({ item }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const description = item.description || "";
    const files = item.files || [];
    const isLongDescription = description.length > 150;
    const toggleExpansion = () => setIsExpanded(!isExpanded);

    return (
        <div style={styles.historyListItemInModal}>
            <div style={styles.historyItemHeader}>
                <h3 style={styles.historyItemTitle}>{item.title}</h3>
                <p style={styles.historyItemDate}>{new Date(item.date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</p>
            </div>
            <p style={styles.historyItemDescription}>{isLongDescription && !isExpanded ? `${description.substring(0, 150)}...` : description}</p>
            {isLongDescription && (<button onClick={toggleExpansion} style={styles.readMoreButton}>{isExpanded ? "Show Less" : "Read More"}</button>)}
            <div>
                <p style={styles.historyItemFilesLabel}>Attached Files</p>
                {files.length > 0 ? (
                    <ul style={styles.historyFileList}>
                        {files.map((file) => (
                            <li key={file._id} style={styles.historyFileItem}>
                                <span style={styles.fileInfo}>{file.originalname}</span>
                                <div style={styles.fileActions}>
                                    <a href={`${BASE_URL}/${file.path?.replace(/\\/g, '/')}`} target="_blank" rel="noopener noreferrer" style={styles.actionIcon} title="View File"><ViewIcon /></a>
                                    <a href={`${BASE_URL}/${file.path?.replace(/\\/g, '/')}`} download={file.originalname} style={styles.actionIcon} title="Download File"><DownloadIcon /></a>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (<p style={{ color: "#888", fontSize: "0.9rem" }}>No files attached.</p>)}
            </div>
        </div>
    );
};


// ========== Main Exportable Component: HistoryViewer (Combined) ==========
const HistoryViewer = ({ caseId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [historyList, setHistoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // Modal বন্ধ থাকলে বা caseId না থাকলে API কল হবে না
    if (!isOpen || !caseId) {
      return;
    }

    const fetchHistory = async () => {
      setLoading(true);
      setError("");
      setHistoryList([]);
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const token = user?.token;
        const res = await fetch(`${BASE_URL}/api/cases/${caseId}/history`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.message || `Failed to fetch history. Status: ${res.status}`);
        }
        const data = await res.json();
        setHistoryList(data?.data?.history || []);
      } catch (err) {
        setError(err.message || "An unknown error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [isOpen, caseId]); // isOpen state-এর ওপর নির্ভর করে API কল হবে

  const triggerButtonStyle = {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'inline-flex',
  };

  return (
    <>
      {/* Step 1: The Trigger Button */}
      <button
        style={triggerButtonStyle}
        onClick={() => setIsOpen(true)} // এই বাটনে ক্লিক করলে মোডাল খুলবে
        aria-label="View case history"
      >
        <HistoryIcon />
      </button>

      {/* Step 2: The Modal (conditionally rendered) */}
      {isOpen && (
        <div style={styles.modalOverlay} onClick={() => setIsOpen(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>History Timeline</h2>
              <button style={styles.closeButton} onClick={() => setIsOpen(false)}>
                <CloseIcon />
              </button>
            </div>
            <div style={styles.modalBody}>
              {loading ? (
                <div style={{ textAlign: 'center', color: '#888', padding: '2rem' }}>Loading...</div>
              ) : error ? (
                <div style={{ textAlign: 'center', color: '#dc2626', padding: '2rem' }}>{error}</div>
              ) : historyList.length > 0 ? (
                historyList.map((item) => <HistoryItem key={item._id} item={item} />)
              ) : (
                <div style={styles.emptyHistoryState}>
                  <h3>No History Found</h3>
                  <p>There are no history records to display for this case.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HistoryViewer;